export const MAJOR_COINS_CHART_OPTIONS = [
  { id: 'donut', label: 'Donut', hint: 'Share split' },
  { id: 'bars', label: 'Bars', hint: 'Ranked list' },
  { id: 'treemap', label: 'Treemap', hint: 'Sized blocks' },
  { id: 'columns', label: 'Columns', hint: 'Vertical rank' },
  { id: 'area', label: 'Area', hint: 'Dominance curve' },
] as const;

export type MajorCoinsChartType = (typeof MAJOR_COINS_CHART_OPTIONS)[number]['id'];

export const DEFAULT_MAJOR_COINS_CHART: MajorCoinsChartType = 'donut';

export function normalizeMajorCoinsChartType(value?: string | null): MajorCoinsChartType {
  const id = (value || '').trim().toLowerCase();
  return MAJOR_COINS_CHART_OPTIONS.some((o) => o.id === id)
    ? (id as MajorCoinsChartType)
    : DEFAULT_MAJOR_COINS_CHART;
}
